import React, { Component } from 'react';
import Toolbar from '../components/Toolbar/Toolbar';
import { SearchInput } from '../components/UI/SearchInput/SearchInput';
import SearchResults from '../components/SearchResults/SearchResults';
import { connect } from 'react-redux';
import * as actions from '../store/actions/index';
import SearchControls from '../components/SearchControls/SearchControls';
import _ from 'lodash';
import './SearchPage.scss';

class SearchPage extends Component {
  state = {
    page: 1,
    sources: [],
    showControls: false
  };

  componentDidMount() {
    this.getInitialSources();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.result, prevProps.result)) {
      this.setState({
        ...this.state,
        showControls: true
      });
    }
  }

  getInitialSources = async () => {
    await this.props.onFetchNowPlaying();
    this.setState({
      sources: this.props.nowPlaying
    });
  };

  onSubmitHandler = evt => {
    evt.preventDefault();
    this.setState(
      {
        page: 1
      },
      () => {
        this.setSearchResults();
      }
    );
  };

  setSearchResults = async () => {
    await this.props.onInfSearch(
      this.props.selectValue,
      this.props.searchQuery,
      this.state.page
    );
    this.setState({
      sources: this.props.result
    });
  };

  nextHandler = () => {
    this.setState(
      {
        page: this.state.page + 1
      },
      () => {
        this.setSearchResults();
        this.scrollToBottom();
      }
    );
  };

  prevHandler = () => {
    if (this.state.page > 1) {
      this.setState(
        {
          page: this.state.page - 1
        },
        () => {
          this.setSearchResults();
          this.scrollToBottom();
        }
      );
    }
  };

  scrollToBottom() {
    this.el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  render() {
    const {
      selectValue,
      maxPages,
      loading,
      searchQuery,
      onSearchQueryChanged,
      onSelectValueChanged
    } = this.props;

    const { page, sources, showControls } = this.state;

    let spinner;

    if (!sources.length) {
      spinner = <div className="main-search-content__loader" />;
    }

    let searchCtrls;
    if (showControls) {
      searchCtrls = (
        <SearchControls
          prevList={this.prevHandler}
          nextList={this.nextHandler}
          disabledPrev={page === 1}
          disabledNext={page === maxPages}
        />
      );
    }

    return (
      <div className="home-container">
        <Toolbar />
        <div className="main-search-content">
          <h1 className="main-search-content_title">
            Search your favorite Movie or TV Show
          </h1>
          <SearchInput
            submitHandler={this.onSubmitHandler}
            searchValue={searchQuery}
            change={onSearchQueryChanged}
            value={selectValue}
            onSelectChange={onSelectValueChanged}
            topRef={el => (this.el = el)}
          />
          <SearchResults result={sources} loading={loading} />
          {spinner}
          {searchCtrls}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectValue: state.searchPageReducer.selectValue,
  result: state.searchPageReducer.result,
  maxPages: state.searchPageReducer.maxPages,
  loading: state.searchPageReducer.loading,
  searchQuery: state.searchPageReducer.searchQuery,
  nowPlaying: state.movieReducer.nowPlaying
});

const mapDispatchToProps = dispatch => ({
  onInfSearch: (type, query, page) =>
    dispatch(actions.infSearch(type, query, page)),
  onSearchQueryChanged: query => dispatch(actions.searchQueryChanged(query)),
  onFetchNowPlaying: () => dispatch(actions.fetchNowPlaying()),
  onChangeTypeMovie: () => dispatch(actions.changeTypeMovie()),
  onChangeTypeTv: () => dispatch(actions.changeTypeTv()),
  onSelectValueChanged: value => dispatch(actions.selectValueChanged(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage);
